import { useNotificationStore } from "@/store2/notification/notification-store";
import { PlatformNoticeModal as CommonPlatformNoticeModal } from "@renderbus/widgets/components/platform-notice-modal";

export function PlatformNoticeModal() {
  const platformNoticeModal = useNotificationStore(
    (s) => s.platformNoticeModal
  );
  const open = useNotificationStore((s) => s.showPlatformNoticeModal);
  const onCloseModal = useNotificationStore((s) => s.onCloseModal);

  return (
    <CommonPlatformNoticeModal
      open={open}
      platformNotice={platformNoticeModal}
      onClose={() => void onCloseModal()}
    />
  );
}
